enum FieldNames {
    ITEM = 'item',
    DEFAULT = 'default',
    VALUE = 'value'
}

export const getIndexedArrayFieldName = (
    arrayFieldName: string,
    index: number,
    namespacingFunction: (name: string) => string
): string => namespacingFunction(`${arrayFieldName}[${index}]`)
export const getIndexedItemFieldName = (
    arrayFieldName: string,
    index: number,
    namespacingFunction: (name: string) => string
): string => namespacingFunction(`${arrayFieldName}[${index}].${FieldNames.ITEM}`)
export const getIndexedDefaultFieldName = (
    arrayFieldName: string,
    index: number,
    namespacingFunction: (name: string) => string
): string => namespacingFunction(`${arrayFieldName}[${index}].${FieldNames.DEFAULT}`)
export const getIndexedValueFieldName = (
    arrayFieldName: string,
    index: number,
    namespacingFunction: (name: string) => string
): string => namespacingFunction(`${arrayFieldName}[${index}].${FieldNames.VALUE}`)

export const getItemFieldName = (namespacingFunction: (name: string) => string): string =>
    namespacingFunction(FieldNames.ITEM)
export const getValueFieldName = (namespacingFunction: (name: string) => string): string =>
    namespacingFunction(FieldNames.VALUE)
